import React, { useState, useEffect } from "react"
import { useIntl, FormattedMessage } from "react-intl"
import formatCurrency from "../../helpers/currencyHelper"
import { AlertError, AlertLoading } from '../../helpers/AlertHelper'

import PaymentsPartnersService from "../../services/PaymentsPartnersService"

import BarChart from "../../components/charts/BarChart"

const PaymentsPartnersReports = ({ onChangeDataset, yearFrom = null, yearTo = null, projectId = null, partnerId = null }) => {
    const intl = useIntl()

    const [paymentsPartnersDataset, setPaymentsPartnersDataset] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(null)

// Verificar si hay filtros aplicados (proyecto O socio)
    const hasFilters = projectId || partnerId

    // Fetch PaymentsPartners dataset
    const fetchPaymentsPartnersDataset = async () => {
        try {
            const response = await PaymentsPartnersService.getPaymentsPartnersDataset({ 
            projectId: projectId || '',
            yearFrom: yearFrom || '',
            yearTo: yearTo || '',
            partnerId: partnerId || ''
        })
        
        const { labels = response.data.dataset.labels || [], datasets = response.data.dataset.datasets || [] } = response.data.dataset
       
            // Construcción del dataset directamente al obtener los datos
             const formattedDataset = {
            labels,
            datasets: [
                {
                    label: intl.formatMessage({ id: "paymentsProjectTotalAmount", defaultMessage: "Total amount payments partners" }),
                    data: datasets[0].data,
                    yAxisID: "y",
                    borderColor: "rgb(53, 162, 235)",
                    backgroundColor: "rgba(53, 162, 235, 0.5)",
                    datalabels: {
                        anchor: 'end',
                        align: 'end',
                        color: '#333',
                        rotation: -45,
                        font: {
                            weight: 'bold',
                            size: 12
                        },
                        formatter: value => formatCurrency(value),
                    },
                },
            ],
        }
        setPaymentsPartnersDataset(formattedDataset)
            onChangeDataset({
                ...formattedDataset,
                datasets: [formattedDataset.datasets[0]],
                totalAmountsSum: response.data.dataset.totalAmountsSum,
                totalPaymentsPartnersSum: response.data.dataset.totalPaymentsPartnersSum
            })
            setIsLoaded(true)
        } catch (err) {
            setIsLoaded(false)
            setError(err)
        }
    }

    // Función para resetear los datos cuando no hay filtros
    const resetData = () => {
        setPaymentsPartnersDataset(null)
        setIsLoaded(false)
        setError(null)
        onChangeDataset({
            labels: [],
            datasets: [],
            totalAmountsSum: 0,
            totalPaymentsPartnersSum: 0
        })
    }

    // Re-fetch data on page/perPage change
    useEffect(() => {
        if (hasFilters) {
            fetchPaymentsPartnersDataset()
        } else {
            resetData()
        }
    }, [yearFrom, yearTo, projectId, partnerId])

     // Si no hay filtros, mostrar mensaje o no mostrar nada
    if (!hasFilters) {
        return (
            <div className="text-center text-muted p-3">
                <p><FormattedMessage id="paymentsPartnersSelectPartner" defaultMessage="Select a project and/or partner to view his individual payments" /></p>
            </div>
        )
    }

    return (
        <>
            {error && <AlertError error={error} />}
            {!isLoaded && <AlertLoading isLoaded={isLoaded} />}
            {isLoaded && (

                <BarChart data={paymentsPartnersDataset} />
            )}
        </>
    )
}

export default PaymentsPartnersReports